import styled from 'styled-components';

export const StyledOverview = styled.div`
  .overview-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .overview-actions-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .overview-actions-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  /* Custom styles for TrakowAssistantButton in Overview */
  .overview-trakow-assistant {
    background: #fff !important;
    border-style: solid !important;
    border-width: 0.0625rem !important;
    border-color: var(--p-color-border-emphasis) !important;
    border-radius: var(--p-border-radius-200) !important;
    color: var(--p-color-text-emphasis) !important;
    padding: 0 8px !important;
    gap: 4px !important;
    height: 28px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    box-shadow: none !important;

    /* Override icon color for Overview */
    svg path {
      fill: var(--p-color-text-emphasis) !important;
    }

    /* Hover state */
    &:hover:not(:disabled) {
      background: #fff !important;
      border-style: solid !important;
      border-width: 0.0625rem !important;
      border-color: var(--p-color-border-emphasis) !important;
      box-shadow: none !important;
      transform: none !important;
    }

    /* Active state */
    &:active:not(:disabled) {
      background: #fff !important;
      border-style: solid !important;
      border-width: 0.0625rem !important;
      border-color: var(--p-color-border-emphasis) !important;
      transform: none !important;
    }
  }
`;
